import { BASE_PATH as h, BaseAPI as O, operationServerMap as P } from "../base.js";
import { DUMMY_BASE_URL as A, assertParamExists as c, createRequestFunction as M, serializeDataIfNeeded as y, setSearchParams as R, toPathString as p } from "../common.js";
import v from "axios";
var _ = function(a) {
  return {
    merchantPmsItemMealAdditionRelAdd: async (n, r = {}) => {
      c("merchantPmsItemMealAdditionRelAdd", "merchantPmsItemMealAdditionRel", n);
      const d = new URL("/merchant_pms_item_meal_addition_rel", A);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "POST",
        ...t,
        ...r
      }, l = {}, i = {};
      l["Content-Type"] = "application/json", R(d, i);
      let s = t && t.headers ? t.headers : {};
      return e.headers = {
        ...l,
        ...s,
        ...r.headers
      }, e.data = y(n, e, a), {
        url: p(d),
        options: e
      };
    },
    merchantPmsItemMealAdditionRelDeleteById: async (n, r = {}) => {
      c("merchantPmsItemMealAdditionRelDeleteById", "relId", n);
      const d = "/merchant_pms_item_meal_addition_rel/{relId}".replace("{relId}", encodeURIComponent(String(n))), t = new URL(d, A);
      let e;
      a && (e = a.baseOptions);
      const l = {
        method: "DELETE",
        ...e,
        ...r
      }, i = {};
      R(t, {});
      let s = e && e.headers ? e.headers : {};
      return l.headers = {
        ...i,
        ...s,
        ...r.headers
      }, {
        url: p(t),
        options: l
      };
    },
    merchantPmsItemMealAdditionRelEdit: async (n, r = {}) => {
      c("merchantPmsItemMealAdditionRelEdit", "merchantPmsItemMealAdditionRel", n);
      const d = new URL("/merchant_pms_item_meal_addition_rel", A);
      let t;
      a && (t = a.baseOptions);
      const e = {
        method: "PUT",
        ...t,
        ...r
      }, l = {}, i = {};
      l["Content-Type"] = "application/json", R(d, i);
      let s = t && t.headers ? t.headers : {};
      return e.headers = {
        ...l,
        ...s,
        ...r.headers
      }, e.data = y(n, e, a), {
        url: p(d),
        options: e
      };
    },
    merchantPmsItemMealAdditionRelGetMealItemDetails: async (n, r = {}) => {
      c("merchantPmsItemMealAdditionRelGetMealItemDetails", "itemId", n);
      const d = "/merchant_pms_item_meal_addition_rel/details/{itemId}".replace("{itemId}", encodeURIComponent(String(n))), t = new URL(d, A);
      let e;
      a && (e = a.baseOptions);
      const l = {
        method: "GET",
        ...e,
        ...r
      }, i = {};
      R(t, {});
      let s = e && e.headers ? e.headers : {};
      return l.headers = {
        ...i,
        ...s,
        ...r.headers
      }, {
        url: p(t),
        options: l
      };
    },
    merchantPmsItemMealAdditionRelGetPackageInfoByItemId: async (n, r = {}) => {
      c("merchantPmsItemMealAdditionRelGetPackageInfoByItemId", "itemId", n);
      const d = "/merchant_pms_item_meal_addition_rel/package/{itemId}".replace("{itemId}", encodeURIComponent(String(n))), t = new URL(d, A);
      let e;
      a && (e = a.baseOptions);
      const l = {
        method: "GET",
        ...e,
        ...r
      }, i = {};
      R(t, {});
      let s = e && e.headers ? e.headers : {};
      return l.headers = {
        ...i,
        ...s,
        ...r.headers
      }, {
        url: p(t),
        options: l
      };
    },
    merchantPmsItemMealAdditionRelGetPage: async (n, r, d = {}) => {
      c("merchantPmsItemMealAdditionRelGetPage", "merchantPmsItemMealAdditionRel", n), c("merchantPmsItemMealAdditionRelGetPage", "page", r);
      const t = new URL("/merchant_pms_item_meal_addition_rel/page", A);
      let e;
      a && (e = a.baseOptions);
      const l = {
        method: "GET",
        ...e,
        ...d
      }, i = {}, s = {};
      if (n !== void 0) for (const [m, u] of Object.entries(n)) s[m] = u;
      if (r !== void 0) for (const [m, u] of Object.entries(r)) s[m] = u;
      R(t, s);
      let o = e && e.headers ? e.headers : {};
      return l.headers = {
        ...i,
        ...o,
        ...d.headers
      }, {
        url: p(t),
        options: l
      };
    },
    merchantPmsItemMealAdditionRelListByItemId: async (n, r = {}) => {
      c("merchantPmsItemMealAdditionRelListByItemId", "itemId", n);
      const d = "/merchant_pms_item_meal_addition_rel/list/{itemId}".replace("{itemId}", encodeURIComponent(String(n))), t = new URL(d, A);
      let e;
      a && (e = a.baseOptions);
      const l = {
        method: "GET",
        ...e,
        ...r
      }, i = {};
      R(t, {});
      let s = e && e.headers ? e.headers : {};
      return l.headers = {
        ...i,
        ...s,
        ...r.headers
      }, {
        url: p(t),
        options: l
      };
    },
    merchantPmsItemMealAdditionRelQueryById: async (n, r = {}) => {
      c("merchantPmsItemMealAdditionRelQueryById", "relId", n);
      const d = "/merchant_pms_item_meal_addition_rel/{relId}".replace("{relId}", encodeURIComponent(String(n))), t = new URL(d, A);
      let e;
      a && (e = a.baseOptions);
      const l = {
        method: "GET",
        ...e,
        ...r
      }, i = {};
      R(t, {});
      let s = e && e.headers ? e.headers : {};
      return l.headers = {
        ...i,
        ...s,
        ...r.headers
      }, {
        url: p(t),
        options: l
      };
    }
  };
}, I = function(a) {
  const n = _(a);
  return {
    async merchantPmsItemMealAdditionRelAdd(r, d) {
      var t, e;
      const l = await n.merchantPmsItemMealAdditionRelAdd(r, d), i = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, s = (e = P["MerchantPmsItemMealAdditionRelApi.merchantPmsItemMealAdditionRelAdd"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (o, m) => M(l, v, h, a)(o, s || m);
    },
    async merchantPmsItemMealAdditionRelDeleteById(r, d) {
      var t, e;
      const l = await n.merchantPmsItemMealAdditionRelDeleteById(r, d), i = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, s = (e = P["MerchantPmsItemMealAdditionRelApi.merchantPmsItemMealAdditionRelDeleteById"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (o, m) => M(l, v, h, a)(o, s || m);
    },
    async merchantPmsItemMealAdditionRelEdit(r, d) {
      var t, e;
      const l = await n.merchantPmsItemMealAdditionRelEdit(r, d), i = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, s = (e = P["MerchantPmsItemMealAdditionRelApi.merchantPmsItemMealAdditionRelEdit"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (o, m) => M(l, v, h, a)(o, s || m);
    },
    async merchantPmsItemMealAdditionRelGetMealItemDetails(r, d) {
      var t, e;
      const l = await n.merchantPmsItemMealAdditionRelGetMealItemDetails(r, d), i = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, s = (e = P["MerchantPmsItemMealAdditionRelApi.merchantPmsItemMealAdditionRelGetMealItemDetails"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (o, m) => M(l, v, h, a)(o, s || m);
    },
    async merchantPmsItemMealAdditionRelGetPackageInfoByItemId(r, d) {
      var t, e;
      const l = await n.merchantPmsItemMealAdditionRelGetPackageInfoByItemId(r, d), i = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, s = (e = P["MerchantPmsItemMealAdditionRelApi.merchantPmsItemMealAdditionRelGetPackageInfoByItemId"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (o, m) => M(l, v, h, a)(o, s || m);
    },
    async merchantPmsItemMealAdditionRelGetPage(r, d, t) {
      var e, l;
      const i = await n.merchantPmsItemMealAdditionRelGetPage(r, d, t), s = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, o = (l = P["MerchantPmsItemMealAdditionRelApi.merchantPmsItemMealAdditionRelGetPage"]) === null || l === void 0 || (l = l[s]) === null || l === void 0 ? void 0 : l.url;
      return (m, u) => M(i, v, h, a)(m, o || u);
    },
    async merchantPmsItemMealAdditionRelListByItemId(r, d) {
      var t, e;
      const l = await n.merchantPmsItemMealAdditionRelListByItemId(r, d), i = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, s = (e = P["MerchantPmsItemMealAdditionRelApi.merchantPmsItemMealAdditionRelListByItemId"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (o, m) => M(l, v, h, a)(o, s || m);
    },
    async merchantPmsItemMealAdditionRelQueryById(r, d) {
      var t, e;
      const l = await n.merchantPmsItemMealAdditionRelQueryById(r, d), i = (t = a == null ? void 0 : a.serverIndex) !== null && t !== void 0 ? t : 0, s = (e = P["MerchantPmsItemMealAdditionRelApi.merchantPmsItemMealAdditionRelQueryById"]) === null || e === void 0 || (e = e[i]) === null || e === void 0 ? void 0 : e.url;
      return (o, m) => M(l, v, h, a)(o, s || m);
    }
  };
}, G = function(a, n, r) {
  const d = I(a);
  return {
    merchantPmsItemMealAdditionRelAdd(t, e) {
      return d.merchantPmsItemMealAdditionRelAdd(t.merchantPmsItemMealAdditionRel, e).then((l) => l(r, n));
    },
    merchantPmsItemMealAdditionRelDeleteById(t, e) {
      return d.merchantPmsItemMealAdditionRelDeleteById(t.relId, e).then((l) => l(r, n));
    },
    merchantPmsItemMealAdditionRelEdit(t, e) {
      return d.merchantPmsItemMealAdditionRelEdit(t.merchantPmsItemMealAdditionRel, e).then((l) => l(r, n));
    },
    merchantPmsItemMealAdditionRelGetMealItemDetails(t, e) {
      return d.merchantPmsItemMealAdditionRelGetMealItemDetails(t.itemId, e).then((l) => l(r, n));
    },
    merchantPmsItemMealAdditionRelGetPackageInfoByItemId(t, e) {
      return d.merchantPmsItemMealAdditionRelGetPackageInfoByItemId(t.itemId, e).then((l) => l(r, n));
    },
    merchantPmsItemMealAdditionRelGetPage(t, e) {
      return d.merchantPmsItemMealAdditionRelGetPage(t.merchantPmsItemMealAdditionRel, t.page, e).then((l) => l(r, n));
    },
    merchantPmsItemMealAdditionRelListByItemId(t, e) {
      return d.merchantPmsItemMealAdditionRelListByItemId(t.itemId, e).then((l) => l(r, n));
    },
    merchantPmsItemMealAdditionRelQueryById(t, e) {
      return d.merchantPmsItemMealAdditionRelQueryById(t.relId, e).then((l) => l(r, n));
    }
  };
}, x = class extends O {
  merchantPmsItemMealAdditionRelAdd(a, n) {
    return I(this.configuration).merchantPmsItemMealAdditionRelAdd(a.merchantPmsItemMealAdditionRel, n).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMealAdditionRelDeleteById(a, n) {
    return I(this.configuration).merchantPmsItemMealAdditionRelDeleteById(a.relId, n).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMealAdditionRelEdit(a, n) {
    return I(this.configuration).merchantPmsItemMealAdditionRelEdit(a.merchantPmsItemMealAdditionRel, n).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMealAdditionRelGetMealItemDetails(a, n) {
    return I(this.configuration).merchantPmsItemMealAdditionRelGetMealItemDetails(a.itemId, n).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMealAdditionRelGetPackageInfoByItemId(a, n) {
    return I(this.configuration).merchantPmsItemMealAdditionRelGetPackageInfoByItemId(a.itemId, n).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMealAdditionRelGetPage(a, n) {
    return I(this.configuration).merchantPmsItemMealAdditionRelGetPage(a.merchantPmsItemMealAdditionRel, a.page, n).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMealAdditionRelListByItemId(a, n) {
    return I(this.configuration).merchantPmsItemMealAdditionRelListByItemId(a.itemId, n).then((r) => r(this.axios, this.basePath));
  }
  merchantPmsItemMealAdditionRelQueryById(a, n) {
    return I(this.configuration).merchantPmsItemMealAdditionRelQueryById(a.relId, n).then((r) => r(this.axios, this.basePath));
  }
};
export {
  x as MerchantPmsItemMealAdditionRelApi,
  _ as MerchantPmsItemMealAdditionRelApiAxiosParamCreator,
  G as MerchantPmsItemMealAdditionRelApiFactory,
  I as MerchantPmsItemMealAdditionRelApiFp
};

//# sourceMappingURL=merchant-pms-item-meal-addition-rel-api.js.map